import { Button } from '@cloudscape-design/components';
import useGetUserById from 'features/user/hooks/useGetUserById';
import PropTypes from 'prop-types';
import React from 'react';
import { useNavigate } from 'react-router-dom';

function UserEmail({ userId = null, backupEmail = null, clickable = false }) {
  const {
    data: user, isFetching, isError, error,
  } = useGetUserById(userId);
  const navigate = useNavigate();

  const display = user?.email || `Anonymous User${backupEmail ? ` (${backupEmail})` : ''}`;
  if (!userId) {
    return <span title={display}>{display}</span>;
  }

  if (isFetching) {
    return <span>{`${userId} (loading email...)`}</span>;
  }

  if (isError) {
    return <span>{`${userId} (Error: ${error.message})`}</span>;
  }

  if (clickable) {
    return (
      <Button variant="inline-link" onClick={() => navigate(`/user/${userId}`)}>
        {display}
      </Button>
    );
  }

  return <span title={display}>{display}</span>;
}

UserEmail.propTypes = {
  userId: PropTypes.string,
  backupEmail: PropTypes.string,
  clickable: PropTypes.bool,
};

export default UserEmail;
